var _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.961426,
    y: 0.964844,
    width: 10.0769,
    height: 10.0769,
    rx: 1.5,
    stroke: "#149752"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.99981,
    cy: 6.00225,
    r: 3.23077,
    fill: "#149752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeg);
export default __webpack_public_path__ + "static/media/veg.4f668b6a5827dd492726f47f95f0a145.svg";
export { ForwardRef as ReactComponent };